import { useRequiredContext } from "@suse-o11y/use-required-context";
import { type ReactElement, createContext } from "react";
// biome-ignore lint/style/noRestrictedImports: component usage
import type { DroppableStateSnapshot } from "react-beautiful-dnd";

export type DroppableContextValue = DroppableStateSnapshot;

const DroppableContext = createContext<null | {
	placeholder: null | ReactElement<HTMLElement>;
	value: DroppableStateSnapshot;
}>(null);

export const DroppableContextProvider = DroppableContext.Provider;

export function useDroppablePlaceholder(): null | ReactElement<HTMLElement> {
	const { placeholder } = useRequiredContext(DroppableContext, {
		providerName: "Droppable",
	});

	return placeholder;
}

export function useDroppableContext(): DroppableContextValue {
	const { value } = useRequiredContext(DroppableContext, {
		providerName: "Droppable",
	});

	return value;
}
